var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "HKLButton",
        _vm._b({ on: { click: _vm.open } }, "HKLButton", _vm.btnAttrs, false)
      ),
      _vm._v(" "),
      _c(
        "HKLModal",
        _vm._g(
          _vm._b({ ref: "modal" }, "HKLModal", _vm.modalAttrs, false),
          _vm.$listeners
        ),
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }